import React from "react";
import LegalPageLayout from "@/components/LegalPageLayout";
import { LEGAL_CONTENT } from "@/data/legalContent";

// Public, unauthenticated route — /dmca
const Dmca = () => {
  const c = LEGAL_CONTENT.dmca;
  return <LegalPageLayout topicKey="dmca" title={c.title} body={c.body} />;
};

export default Dmca;
